import {
	TASK_LIST,
	TASK_VARIANTS,
	Experiment,
	Experience,
	ProjectStyle,
	ProjectProperties,
	UserRole,
	Edition,
	Route,
	Permissions,
	Trait,
} from './constants.tsx';

export const JSW = {
	taskList: TASK_LIST,
	taskVariants: TASK_VARIANTS,
	experiment: Experiment,
	experience: Experience,
	projectStyle: ProjectStyle,
	projectProperties: ProjectProperties,
	userRole: UserRole,
	edition: Edition,
	route: Route,
	permissions: Permissions,
	trait: Trait,
} as const;
